const mod = crateImports["@xing-com/crate-communication-tracking"];
const { ENDPOINT,SCHEMA_VERSION,useTracking,useViewerDataEventual } = mod;
export { ENDPOINT,SCHEMA_VERSION,useTracking,useViewerDataEventual };
export default mod.default ?? mod;